module.exports = __webpack_public_path__ + "images/category_bulk_estimate_btn_hover_e2dfea87fa4a0e039f146e3709fdb335.png";